/* eslint-disable valid-typeof */
/* eslint-disable no-return-assign */
import React from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import './paquete-detalle-panel-comprar.css';
import ShareButtons from 'frontend/commons/social-networks/ShareButtons';
import { withTranslation } from 'react-i18next';
import IataCode from 'frontend/commons/IataCode';
import OpcionesPago from '../../../commons/ver-financiacion';
import PriceFromDetails from '../components/PriceFromDetails';

class PanelPrincipal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { props } = this;
    const { precioUnitarioFormateado, t } = props;

    const precio = precioUnitarioFormateado || t('layout:packages.details.not_available');

    const imagenPaquete = props.paquete.imagen
      ? props.paquete.imagen
      : `${process.env.RAZZLE_URL}/assets/img/paquete-por-defecto.jpg`;
    const imagenPrincipal = `https://${imagenPaquete}`;

    let queryString = '?type=Paquete';

    if (props.referencia !== '' && props.referencia !== undefined) {
      const distribucion = `&h=${props.distribucion}`;
      const referencia = `&referencia=${props.referencia}`;
      const proveedorId = `&proveedorId=${props.proveedorId}`;
      const fechaSalida = props.paquete.salidas[0].fechaSalida ? `&desde=${props.paquete.salidas[0].fechaSalida}` : '';
      const destino = props.paquete.salidas[0].destinoIata ? `&destino=${props.paquete.salidas[0].destinoIata}` : '';
      const cantidadNoches = props.paquete.cantNoches ? `&cantidadNoches=${props.paquete.cantNoches}` : '';

      queryString = `${'?type=PaqueteAMedida'}${referencia}${distribucion}${proveedorId}${destino}${fechaSalida}${cantidadNoches}`;
    }

    const botonComprar = () => {
      if (props.paquete.pasajeros.length
        > props.paquete.salidas[0].cupos
        || props.cantidadPasajeros > props.paquete.salidas[0].cupos
        || props.paquete.salidas[0].cupos === undefined) {
        return null;
      }
      return (
        <Link
          to={{
            pathname: '/checkout',
            search: `?t=${props.referencia}&h=${props.distribucion}&p=${props.proveedorId}`,
          }}
          className='btn paquete-detalle btn-detalle btn-width inline-block text-center'
        >
          {t('layout:packages.details.buy')}
        </Link>
      );
    };

    const botonReserva = () => (
      <a
        href={`${process.env.RAZZLE_URL_PATH}/consulta${queryString}`}
        className='btn paquete-detalle btn-width color-btn-res inline-block text-center bg-mbr-color-primario'
      >
        {t('layout:packages.details.consult')}
      </a>
    );

    const iconoHomologado = {
      vuelo: 'fas fa-plane',
      asistencia: 'fas fa-medkit',
      traslados: 'fas fa-car',
      hotel: 'fas fa-bed',
      excursiones: 'fas fa-ticket',
      auto: 'fas fa-car',
      guia: 'fas fa-map',
    };

    const generarIconosServicios = () => {
      if (props.paquete.salidas[0] !== undefined) {
        if (props.paquete.salidas[0].tipoServicios === !null || props.paquete.salidas[0].tipoServicios.length > 0) {
          const servicios = props.paquete.salidas[0].tipoServicios;
          return servicios.map((servicioId, indice) => {
            const icono = props.paquete.proveedorId === 1
              ? `fa ${servicioId}`
              : iconoHomologado[servicioId];
            return (
              <span key={`service-${icono}`} className='icon-services bg-mbr-color-primario'>
                <i className={icono} />
              </span>
            );
          });
        }
      }
      return null;
    };

    const renderStar = (quantity) => {
      if (quantity === 0) return null;

      const stars = [1, 2, 3, 4, 5];
      return (
        <span className='stars-container'>
          {stars.map((currentValue) => {
            const className
            = currentValue <= quantity
              ? 'fa fa-star yellow'
              : 'fa fa-star icon-gray';
            return (
              <div className='inline' key={currentValue}>
                <i className={className} aria-hidden='true' />
              </div>
            );
          })}
        </span>
      );
    };

    let primerHotel = '';

    if (props.paquete.salidas[0].hoteles.length > 0) {
      const { hoteles } = props.paquete.salidas[0];
      primerHotel = (
        <div className='hotel-item-container'>
          <div className='hotel'>
            <span className='nombre-hotel'>
              {`${hoteles[0].nombre} `}
            </span>
            {renderStar(hoteles[0].clase)}
          </div>
          <div className='habitacion'>
            {
              hoteles[0].tipoHabitacion !== null
                ? (props.paquete.proveedorId !== 1
                  ? `HAB. ${hoteles[0].tipoHabitacion.replace('|', ' | ')}`
                  : `HAB. ${hoteles[0].tipoHabitacion}`)
                : (null)
            }
            {' '}
            {hoteles[0].regimen !== null
              ? (<span className='regimen'>{hoteles[0].regimen}</span>)
              : (null)}
          </div>
        </div>
      );
    }

    const mobile = isClient ? window.innerWidth <= 768 : false;
    const formatoDia = mobile ? 'ddd D' : 'dddd D';
    const formatoMes = mobile ? 'MMM' : 'MMMM';

    const salida = `Salida ${
      Moment(props.paquete.salidas[0].fechaSalida).format(formatoDia)} de ${
      Moment(props.paquete.salidas[0].fechaSalida).format(formatoMes)}`;

    const armarInfoAerolinea = (transporte) => {
      const elemento = '';

      if (transporte.img === 'Aerolineas Argentinas') {
        return (
          <div className='texto-transporte'>
            {`${t('layout:packages.details.traveling_with')} `}
            <b className='inline-block'>
              {transporte.nombreTransporte}
            </b>
          </div>
        );
      }
      if (transporte.img.length > 3) {
        return (
          <img
            src={`https://www.ola.com.ar${transporte.img}`}
            title={transporte.nombreTransporte}
            alt='transporte'
            className='img-responsive'
            height='35px'
            width='85px'
          />
        );
      }
      if (transporte.nombreTransporte.length > 1) {
        return (
          <div className='texto-transporte'>
            {`${t('layout:packages.details.traveling_with')} `}
            <b className='inline-block'>
              {transporte.nombreTransporte}
            </b>
          </div>
        );
      }
      return elemento;
    };

    const transporteElemento = () => {
      const datos = props.paquete;
      let img = '';
      let nombreTransporte = '';
      if (datos.salidas[0].transporte.transporteAereo !== null) {
        img = datos.salidas[0].transporte.transporteAereo.imagen === null || datos.salidas[0].transporte.transporteAereo.imagen === undefined
          ? ''
          : datos.salidas[0].transporte.transporteAereo.imagen;
        nombreTransporte = datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
          ? ''
          : datos.salidas[0].transporte.transporteAereo.nombreLineaAerea;
      }

      const transporte = {
        img,
        nombreTransporte,
      };

      return armarInfoAerolinea(transporte);
    };

    let { cupos } = props.paquete.salidas[0];
    cupos = cupos !== 0
      ? t('layout:packages.details.spaces', { number: cupos })
      : t('layout:packages.details.checkAvailability');

    return (
      <div className='precio info'>
        <div className='panel panel-default custom paquete container' ref={(el) => this.details = el}>
          <div className='paquete relative bg-white'>
            <div className='grid grid-cols-12'>
              <div className='col-span-12 md:col-span-6'>
                <img
                  style={{ width: '100%', height: 363, objectFit: 'cover' }}
                  src={imagenPrincipal}
                  alt='Img de tu destino'
                />
                <div className='cupos-imagen bg-mbr-color-primario'>
                  {cupos}
                </div>
              </div>
              <div className='col-span-12 md:col-span-6 px-4'>
                <div className='grid grid-cols-2 gap-4'>
                  <div className='col-span-2 md:col-span-1'>
                    <div className='detalle detalle-height text-wrapper'>
                      <div className='nombre block truncate'>
                        {ReactHtmlParser(props.paquete.nombre)}
                      </div>
                      <div className='noches'>
                        {`${props.paquete.cantNoches} ${t('layout:packages.details.nights')}`}
                      </div>
                      <div className='lista-hoteles'>
                        {primerHotel}
                      </div>
                      <div className='services'>
                        {generarIconosServicios()}
                      </div>
                    </div>
                  </div>
                  <div className='col-span-2 md:col-span-1'>
                    <div className='panel-precio'>
                      <div className='grid grid-cols-2'>
                        <div className='col-span-1 md:col-span-2'>
                          <div className='precio precio-size'>
                            <PriceFromDetails />
                          </div>
                          <div className='info-precio precio-texto'>
                            {t('layout:packages.details.price_per_person_travel', { number: props.cantidadPasajeros })}
                          </div>
                        </div>
                        <div className='col-span-1 md:col-span-2 md:hidden'>
                          {botonComprar()}
                          {botonReserva()}
                        </div>
                        <div className='col-md-12 col-lg-12 hidden-xs'>
                          <div className='row'>
                            <div className='pago-cuotas-disponible'>
                              <OpcionesPago
                                id={props.paquete.idProducto}
                                uniqueId={props.indice}
                                appId={props.paquete.applicationId}
                                price={precio}
                                customText={(
                                  <span>
                                    <i className='fa fa-chevron-down' />
                                    {' '}
                                    Formas de pago
                                  </span>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='sub-panel margin-subpanel flex justify-between'>
                  <div className='text-sm text-gray-600'>
                    {ReactHtmlParser(salida)}
                    &nbsp;
                    <span>
                      <IataCode
                        concatStart={t('translations:shared.from').toLowerCase()}
                        code={props.paquete.salidas[0].origenIata.split(';')[0]}
                      />
                    </span>
                  </div>
                  <div>
                    {transporteElemento()}
                  </div>
                </div>
                <div className='hidden md:block'>
                  {botonComprar()}
                  {botonReserva()}
                  {typeof 'window' !== undefined && (
                    <ShareButtons
                      imageUrl={imagenPrincipal}
                      title={props.paquete.nombre}
                      date={Moment(props.paquete.salidas[0].fechaSalida).format('DD-MM-YYYY')}
                      reference={props.referencia}
                      distribution={props.distribucion}
                      supplierId={props.proveedorId}
                      price={precio}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(withTranslation()(PanelPrincipal));
